module.exports = __webpack_public_path__ + "static/media/dennis_1.36e45600.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/ExampleCarousel/assets/dennis_1.jpg
// module id = 450
// module chunks = 0